export default __webpack_public_path__ + "assets/eb6959f2e77471de8680b727b7a79fad.jpg";